import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { getUser, invoke } from '../../AppServices';
import { modifyDateView } from '../../Lib/helpers';
import { Text, View } from '@applane/react-core-components';
import Calender from './Calender';
import { ftsThemeMD } from '../../theme/ftsTheme';
import vars from '../../theme/vars';
import ViewButtonsLists from './ViewButtonsLists';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { Menu, MenuItem } from '@mui/material';
import { ViewAppraisalResult } from './View';
import './Calender.css';

export default function Test1() {
  const [data, setData] = useState([]);
  const [value, setValue] = useState([null, null]);
  const [inputValue, setInputValue] = useState('');
  const [id, setId] = useState('');
  const [view, setView] = useState(false);
  const isRender = useRef(true);
  const dataLength = useRef(data.length);
  const delayTimeout = useRef(null);
  const [dataFound, setDataFound] = useState(null);
  const tableContainerRef = useRef < HTMLDivElement > null;
  let isFirstRender = true;
  const [filteredRows, setFilteredRows] = useState(data || []);
  const fetchMoreOnBottomReached = useCallback(async (containerRefElement) => {
    if (containerRefElement) {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      if (scrollHeight - scrollTop - clientHeight < 1) {
        await fetch();
      }
    }
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0); // Track the current page
  const pageSize = 20; // Number of items per page

  const user = getUser();
  const userRole = user?.role?.code;

  const fetch = async () => {
    setIsLoading(true);
    try {
      let filter = {
        $or: [
          // { dms: { repairOrderNumber: { $regex: inputValue, $options: 'i' } } },
          { dms: { contactNumber: { $regex: inputValue, $options: 'i' } } },
          { dms: { email: { $regex: inputValue, $options: 'i' } } },
          { dms: { vin: { $regex: inputValue, $options: 'i' } } },
          { dms: { name: { $regex: inputValue, $options: 'i' } } },
        ],
      };

      if (
        userRole === 'dealer' ||
        userRole === 'superdealer' ||
        userRole === 'employee' ||
        userRole === 'manager'
      ) {
        filter = {
          ...filter,
          dealer: { _id: user.dealer?._id },
        };
      }

      let skip = page * pageSize; // Calculate skip based on page
      await fetchData(pageSize, skip, filter);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async (limit, skip, filter) => {
    if (value[0] && value[1]) {
      const startDate = new Date(value[0]);
      startDate.setUTCHours(startDate.getUTCHours() + 5); // Adjust to UTC+5:00
      const endDate = new Date(value[1]);
      endDate.setUTCHours(endDate.getUTCHours() + 5);

      filter = {
        ...filter,
        onDate: {
          $gte: startDate.toISOString(),
          $lte: endDate.toISOString(),
        },
      };
    }

    const { result } = await invoke({
      id: '_find',
      paramValue: {
        query: {
          id: 'allData',
          addOnFilter: { type: 'avgen', ...filter },
          limit,
          skip,
          skipAggregates: false,
        },
        model: 'AppraisalResultCDK',
      },
    });
    if (result?.length) {
      setData((prevData) => [...prevData, ...result]);
      setDataFound(true);
    } else {
      setData([]);
      setDataFound(false);
    }
  };

  // Handle next page
  const handleNext = () => {
    setPage((prev) => prev + 1);
  };

  // Handle previous page
  const handlePrevious = () => {
    setPage((prev) => Math.max(prev - 1, 0));
  };

  // Refetch data when page changes
  useEffect(() => {
    fetch();
  }, [page]);

  useEffect(() => {
    if (value[0]) {
      if (value[0] && value[1]) {
        console.log('value handler running');
        setData([]); // Reset data before fetching new data
        fetch();
      }
    } else if (value[0] === null && value[1] === null) {
      if (isRender.current) {
        return;
      }
      console.log('value handler running else if');

      setData([]);
      fetch();
    }
  }, [value]);

  useEffect(() => {
    if (isRender.current) {
      isRender.current = false;
      return;
    }
    clearTimeout(delayTimeout.current);
    delayTimeout.current = setTimeout(() => {
      console.log('inputValue changed, fetching data');
      setData([]);
      fetch();
    }, 500);
  }, [inputValue]);

  console.log('F16', data);

  const headCellsData = [
    {
      id: 'index',
      numeric: false,
      disablePadding: true,
      label: '#',
    },
    {
      id: 'repairOrderNumber',
      numeric: true,
      disablePadding: false,
      label: 'Appraisal#',
    },
    {
      id: 'name',
      numeric: true,
      disablePadding: false,
      label: 'Customer Name',
    },
    {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: 'Customer Email',
    },
    {
      id: 'contactNumber',
      numeric: true,
      disablePadding: false,
      label: 'Contact Number',
    },
    {
      id: 'customerInterest',
      numeric: true,
      disablePadding: false,
      label: 'Customer Interest',
    },
    {
      id: 'vin',
      numeric: true,
      disablePadding: false,
      label: 'VIN',
    },
    {
      id: 'make',
      numeric: true,
      disablePadding: false,
      label: 'Make',
    },
    {
      id: 'model',
      numeric: true,
      disablePadding: false,
      label: 'Model',
    },
    {
      id: 'year',
      numeric: true,
      disablePadding: false,
      label: 'Year',
    },
    {
      id: 'mileage',
      numeric: true,
      disablePadding: false,
      label: 'Mileage',
    },
    {
      id: 'generated',
      numeric: true,
      disablePadding: false,
      label: 'Generated',
    },
    {
      id: 'originalValue',
      numeric: true,
      disablePadding: false,
      label: 'Original Value',
    },
    {
      id: 'spread',
      numeric: true,
      disablePadding: false,
      label: 'Spread',
    },
    {
      id: 'enhance',
      numeric: true,
      disablePadding: false,
      label: 'Enhancement',
    },
    {
      id: 'finalRange',
      numeric: true,
      disablePadding: false,
      label: 'Range',
    },
    {
      id: 'deliveryDate',
      numeric: true,
      disablePadding: false,
      label: 'Last Purchased Date',
    },
    {
      id: 'offerList',
      numeric: true,
      disablePadding: false,
      label: 'Offer List',
    },
    {
      id: 'status',
      numeric: true,
      disablePadding: false,
      label: 'SMS Status',
    },
    {
      id: 'contacted',
      numeric: true,
      disablePadding: false,
      label: 'Contacted',
    },
  ];

  const [headCells, setHeadCells] = React.useState(headCellsData);

  const rows = data?.map((obj, index) => ({
    index,
    id: obj.dms._id,
    repairOrderNumber: obj.dms.repairOrderNumber,
    name: obj.dms.name,
    email: obj.dms.email,
    contactNumber: obj.dms.contactNumber,
    customerInterest: obj.customerInterest,
    vin: obj.dms.vin,
    make: obj.dms.make,
    model: obj.dms.model,
    year: obj.dms.year,
    mileage: obj.dms.mileage,
    generated: obj.onDate,
    originalValue: obj.originalValue,
    spread: obj.spread,
    enhance: obj.enhance,
    finalRange: obj.finalRange,
    deliveryDate: obj.dms.deliveryDate,
    offerList: obj.offerList,
    status: obj.status,
  }));

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });

  const handleExportData = () => {
    // Customize data array based on columns

    const customizedData = data.map((item) => ({
      'Appraisal#': item.dms.repairOrderNumber,
      'Customer Name': item.dms.name,
      'Customer Email': item.dms.email,
      'Customer Interest': item.customerInterest ? 'Yes' : 'No',
      VIN: item.dms.vin,
      Make: item.dms.make,
      Model: item.dms.model,
      Year: item.dms.year,
      Mileage: item.dms.mileage,
      Generated: modifyDateView(item.onDate),
      Contacted: item.contacted ? 'Yes' : 'No', // Assuming HandleSpokenToCustomer is a component
      'Offer List': item.offerList.join(', '),
      'Original Value': item.originalValue,
      Spread: item.spread,
      Enhancement: item.enhance,
      Range: item.finalRange,
    }));

    const csv = generateCsv(csvConfig)(customizedData);
    download(csvConfig)(csv);
  };

  const handleExportRows = () => {
    const rowData = data.filter((item) => selected.includes(item?._id));
    console.log('rowData', rowData);
    const customizedData = rowData.map((item) => ({
      'Appraisal#': item.dms.repairOrderNumber,
      'Customer Name': item.dms.name,
      'Customer Email': item.dms.email,
      'Customer Interest': item.customerInterest ? 'Yes' : 'No',
      VIN: item.dms.vin,
      Make: item.dms.make,
      Model: item.dms.model,
      Year: item.dms.year,
      Mileage: item.dms.mileage,
      Generated: modifyDateView(item.onDate),
      Contacted: item.contacted ? 'Yes' : 'No', // Assuming HandleSpokenToCustomer is a component
      'Offer List': item.offerList.join(', '),
      'Original Value': item.originalValue,
      Spread: item.spread,
      Enhancement: item.enhance,
      Range: item.finalRange,
    }));

    console.log('Test', customizedData);

    const csv = generateCsv(csvConfig)(customizedData);
    download(csvConfig)(csv);
  };

  function EnhancedTableHead(props) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              style={{
                marginInline: 'auto',
              }}
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all',
              }}
            />
          </TableCell>
          {headCells.map((headCell, i) => (
            <>
              <TableCell
                key={headCell.id}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
                style={{
                  fontSize: '18px',
                  whiteSpace: 'nowrap',
                  minWidth: 70,
                }}>
                {headCell?.label === '#' ? (
                  <p style={{ textAlign: 'center' }}>{headCell.label}</p>
                ) : (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                    style={{
                      fontSize: '18px',
                      whiteSpace: 'nowrap',
                    }}>
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                )}
              </TableCell>
            </>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIds, setSelectedIds] = useState(
    headCellsData.map((cell) => cell.id),
  );

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        // If already selected, remove it
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        // If not selected, add it
        return [...prevSelectedIds, id];
      }
    });
  };

  React.useEffect(() => {
    // Filter the header cells
    setHeadCells(headCellsData.filter((cell) => selectedIds.includes(cell.id)));

    // Filter the rows data
    const filteredRows = data?.map((obj, index) => {
      const filteredRow = {};
      selectedIds.forEach((id) => {
        filteredRow.id = obj._id;
        switch (id) {
          case 'index':
            filteredRow.index = index + 1;
            break;
          case 'repairOrderNumber':
            filteredRow.repairOrderNumber = obj.dms.repairOrderNumber
              ? obj.dms.repairOrderNumber
              : 'N/A';
            break;
          case 'name':
            filteredRow.name = obj.dms.name ? obj.dms.name : 'N/A';
            break;
          case 'email':
            filteredRow.email = obj.dms.email ? obj.dms.email : 'N/A';
            break;
          case 'contactNumber':
            filteredRow.contactNumber = obj?.dms?.contactNumber
              ? obj?.dms?.contactNumber
              : 'N/A';
            break;
          case 'customerInterest':
            filteredRow.customerInterest = obj.customerInterest
              ? obj.customerInterest
              : false;
            break;
          case 'vin':
            filteredRow.vin = obj.dms.vin ? obj.dms.vin : 'N/A';
            break;
          case 'make':
            filteredRow.make = obj.dms.make ? obj.dms.make : 'N/A';
            break;
          case 'model':
            filteredRow.model = obj.dms.model ? obj.dms.model : 'N/A';
            break;
          case 'year':
            filteredRow.year = obj.dms.year ? obj.dms.year : 'N/A';
            break;
          case 'mileage':
            filteredRow.mileage = obj.dms.mileage ? obj.dms.mileage : 'N/A';
            break;
          case 'generated':
            filteredRow.generated = obj.onDate ? obj.onDate : 'N/A';
            break;
          case 'originalValue':
            filteredRow.originalValue = obj.originalValue
              ? obj.originalValue
              : 'N/A';
            break;
          case 'spread':
            filteredRow.spread = obj.spread ? obj.spread : 'N/A';
            break;
          case 'enhance':
            filteredRow.enhance = obj.enhance ? obj.enhance : 'N/A';
            break;
          case 'finalRange':
            filteredRow.finalRange = obj.finalRange ? obj.finalRange : 'N/A';
            break;
          case 'deliveryDate':
            filteredRow.deliveryDate = obj.dms.deliveryDate
              ? obj.dms.deliveryDate
              : ['N/A'];
            break;
          case 'offerList':
            filteredRow.offerList = obj.offerList ? obj.offerList : 'N/A';
            break;
          case 'status':
            filteredRow.status = obj.status ? obj.status : 'N/A';
            break;
          case 'contacted':
            filteredRow.contacted = obj.contacted ? obj.contacted : false;
            break;
          default:
            break;
        }
      });
      return filteredRow;
    });

    // Set the filtered rows to state or use them directly
    setFilteredRows(filteredRows);
    console.log('Filtered Rows:', filteredRows);
  }, [selectedIds, data]);

  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}>
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={handleExportData}
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Export All Data
        </Button>
        {/* <Button
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Export All Rows
        </Button> */}
        <Button
          disabled={selected.length === 0}
          //only export selected rows
          onClick={() => handleExportRows(selected)}
          startIcon={
            <FileDownloadIcon
              style={{
                fontSize: '1.5rem',
              }}
            />
          }
          style={{
            fontSize: '1.5rem',
          }}
          className="exportButton">
          Selected Rows
        </Button>
      </Box>
    );
  }

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    console.log('Test 2', filteredRows);
    if (event.target.checked) {
      const newSelected = filteredRows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleRowSelection = (id) => {
    console.log('selected', selected);
    if (selected.includes(id)) {
      setSelected(selected.filter((item) => item !== id));
    } else {
      setSelected((prev) => [...prev, id]);
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;
  console.table({
    order,
    orderBy,
    page,
    rowsPerPage,
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredRows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filteredRows],
  );

  // console.log('Visible rows', visibleRows);

  // useEffect(() => {
  //   if (data.length === 0) {
  //     setIsLoading(true);
  //   } else {
  //     setIsLoading(false);
  //   }
  //   // setIsLoading(true);
  // }, [data, setData]);

  const { headings } = vars;

  const textStyle = { ...headings.pageHeading, marginLeft: 12 };

  const {
    searchContainerStyle,
    inputStyle,
    searchImageStyle,
    crossImageStyle,
  } = ftsThemeMD;

  return (
    <>
      <div
        className="d-block d-sm-flex p-md-1"
        style={{ justifyContent: 'between' }}>
        <Text className="mt-md-3" style={textStyle}>
          {view ? 'View Appraisal Generated' : 'Appraisals Generated List'}
        </Text>

        <div style={{ marginLeft: 'auto' }} className="ps-3 ps-md-0 mb-md-2">
          {!view ? (
            <div className="d-flex align-items-center">
              <View style={{ ...searchContainerStyle, marginTop: '0.6rem' }}>
                <input
                  type="search"
                  style={inputStyle}
                  placeholder={'Search by Appraisal#/VIN/Mobile/Email'}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                  }}
                />
              </View>
              <div className="ps-md-1">
                <Calender value={value} setValue={setValue} />
              </div>
            </div>
          ) : (
            <ViewButtonsLists id={id} setView={setView} avgen={true} />
          )}
        </div>
      </div>
      <Box sx={{ width: '100%', maxHeight: '100%', border: 'none' }}>
        <div sx={{ width: '100%', border: 'none' }}>
          {!view ? (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <div>
                  <Button style={{ fontSize: 13 }} onClick={handleMenuOpen}>
                    Filter Columns
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    style={{
                      gap: 0,
                      fontSize: 12,
                    }}>
                    {headCellsData.map((cell) => (
                      <MenuItem key={cell.id} style={{ fontSize: 12 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{
                                padding: 0,
                                paddingRight: 5,
                              }}
                              checked={selectedIds.includes(cell.id)}
                              onChange={() => handleCheckboxChange(cell.id)}
                            />
                          }
                          label={cell.label}
                        />
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </div>

              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  className="tableBoxHeight">
                  <div class="loader12"></div>
                </div>
              ) : (
                <>
                  {!dataFound ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                      }}
                      className="tableBoxHeight">
                      <p
                        style={{
                          fontSize: '16px',
                          fontWeight: 'normal',
                        }}>
                        Data not found...
                      </p>
                    </div>
                  ) : (
                    <TableContainer
                      // onScroll={(event) => fetchMoreOnBottomReached(event.target)}
                      style={{
                        position: 'relative',
                      }}
                      className="tableBoxHeight">
                      <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}>
                        <EnhancedTableHead
                          numSelected={selected.length}
                          order={order}
                          orderBy={orderBy}
                          onSelectAllClick={handleSelectAllClick}
                          onRequestSort={handleRequestSort}
                          rowCount={filteredRows.length}
                        />
                        <TableBody
                          style={{
                            maxHeight: '500px',
                            overflowY: 'auto',
                          }}>
                          {visibleRows.map((row, index) => {
                            const isItemSelected = selected.includes(row.id);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                onClick={() => {
                                  setId(row.id);
                                  setView(true);
                                }}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.id}
                                selected={isItemSelected}
                                sx={{ cursor: 'pointer' }}>
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    color="primary"
                                    checked={isItemSelected}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() => {
                                      handleRowSelection(row.id);
                                    }}
                                    inputProps={{
                                      'aria-labelledby': labelId,
                                    }}
                                  />
                                </TableCell>
                                {row.index && (
                                  <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none">
                                    <p
                                      style={{
                                        fontSize: '16px',
                                        width: '100%',
                                        textAlign: 'center',
                                      }}>
                                      {row.index}
                                    </p>
                                  </TableCell>
                                )}
                                {row.repairOrderNumber && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.repairOrderNumber}
                                  </TableCell>
                                )}
                                {row.name && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.name}
                                  </TableCell>
                                )}
                                {row.email && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.email}
                                  </TableCell>
                                )}
                                {row.contactNumber && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.contactNumber}
                                  </TableCell>
                                )}
                                {(row.customerInterest === true ||
                                  row.customerInterest === false) && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    <input
                                      type="checkbox"
                                      style={{ marginLeft: '70px' }}
                                      checked={row.customerInterest}
                                    />
                                  </TableCell>
                                )}
                                {row.vin && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.vin}
                                  </TableCell>
                                )}
                                {row.make && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.make}
                                  </TableCell>
                                )}
                                {row.model && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.model}
                                  </TableCell>
                                )}
                                {row.year && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.year}
                                  </TableCell>
                                )}
                                {row.mileage && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.mileage}
                                  </TableCell>
                                )}
                                {row.generated && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {modifyDateView(row.generated)}
                                  </TableCell>
                                )}
                                {row.originalValue && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.originalValue}
                                  </TableCell>
                                )}
                                {row.spread && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.spread}
                                  </TableCell>
                                )}
                                {row.enhance && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.enhance}
                                  </TableCell>
                                )}
                                {row.finalRange && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.finalRange}
                                  </TableCell>
                                )}
                                {row.deliveryDate && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {!row.deliveryDate
                                      ? ''
                                      : row.deliveryDate ===
                                          'Never Purchased' ||
                                        row.deliveryDate ===
                                          '1970-01-01T00:00:00.000Z'
                                      ? 'Never Purchased'
                                      : modifyDateView(row.deliveryDate)}
                                  </TableCell>
                                )}
                                {row.offerList && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.offerList?.map((offer) => (
                                      <p key={offer}>{offer}</p>
                                    ))}
                                  </TableCell>
                                )}
                                {row.status && (
                                  <TableCell
                                    align="left"
                                    sx={{ fontSize: 16, whiteSpace: 'nowrap' }}>
                                    {row.status}
                                  </TableCell>
                                )}
                                {/* {(row.contacted === true || row.contacted === false) && ( */}
                                <TableCell padding="checkbox">
                                  <div
                                    style={{
                                      width: '100%',
                                      textAlign: 'center',
                                    }}>
                                    <Checkbox
                                      color="primary"
                                      checked={row.contacted}
                                      disabled={true}
                                      // onChange={() => handleRowSelection(row.id)}
                                      inputProps={{
                                        'aria-labelledby': labelId,
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                {/* )} */}
                              </TableRow>
                            );
                          })}
                          {emptyRows > 0 && (
                            <TableRow
                              style={{
                                height: (dense ? 33 : 53) * emptyRows,
                              }}>
                              <TableCell colSpan={6}></TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </>
              )}
            </>
          ) : (
            <ViewAppraisalResult id={id} />
          )}
        </div>

        {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
      </Box>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          gap: 10,
          paddingTop: 8,
          paddingRight: 15,
        }}>
        <button
          className="paginationBtn"
          onClick={handlePrevious}
          disabled={page === 0}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-left">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <button
          className="paginationBtn"
          disabled={!dataFound}
          onClick={handleNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-right">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </>
  );
}
